module.exports = __webpack_public_path__ + "static/img/3.02e22411.png";